<footer id="footer">
    <!-- Widget Footer -->
    <div class="footer-content dark">
        <div class="container">
                <div class="row">
                    <div class="col-lg-3">
                        <div class="widget">
                            
                            <!-- <div class="widget-title">Categorie</div>-->
                            <ul class="list">
                                <li><a routerLink="/privacy">Privacy Policy</a></li>
                                <li><a routerLink="/informativa">Informativa e-commerce</a></li>
                            </ul> 
                        </div>
                    </div>
    
                    <div class="col-lg-3">
                        <div class="widget">
                            <!-- <div class="widget-title">Utility</div> -->
                            <ul class="list">
                                
                                <li><a routerLink="/recesso">Recesso</a></li>
                                <!-- <li><a href="#">Spedizione e Resi</a></li> -->
                            </ul>
                        </div>
                    </div>
                    <div class="col-lg-3">
                        <div class="widget">
                            
                            <ul class="list">
                                <li><a routerLink="/contatti">Contattaci</a></li>
                                <li><a routerLink="/accedi">Accedi</a></li>
                            </ul> 
                        </div>
                    </div>
                    <div class="col-lg-3">
                        <div class="widget">
                            <!-- <div class="widget-title">Contatti</div> -->
                            <ul class="list">
                                
                                <li><a routerLink="/registrati">Registrati</a></li>
                                <li><a href="#">Recupera Password</a></li>
                            </ul>
                        </div> 
                    </div>
                </div>

                <div class="row" *ngIf="type == 1">
                    <div class="col-lg-6" style="color:#6ebbda">
                        È disponibile la nostra nuova App, clicca<br>
                        sul pulsante del tuo store per scaricarla: 
                    </div>
                    <div class="col-lg-3">
                        <a href="https://apps.apple.com/us/app/pro-dis-b2b/id1630776015" target="_blank">
                            <img src="../../../../../assets/images/appBtnApple.png">
                        </a>
                    </div>
                    <div class="col-lg-3">
                        <a href="https://play.google.com/store/apps/details?id=it.ideainnova.prodisl" target="_blank">
                            <img src="../../../../../assets/images/appBtnAndroid.png">
                        </a>
                    </div>
                </div>

                <div class="row" *ngIf="type == 2">
                    <div class="col-lg-6" style="color:#6ebbda">
                        È disponibile la nostra nuova App, clicca<br>
                        sul pulsante del tuo store per scaricarla: 
                    </div>
                    <div class="col-lg-3">
                        <a href="https://apps.apple.com/it/app/ingromarket-b2b/id1607158128" target="_blank">
                            <img src="../../../../../assets/images/appBtnApple.png">
                        </a>
                    </div>
                    <div class="col-lg-3">
                        <a href="https://play.google.com/store/apps/details?id=it.dcwebservice.ingromarketsrl" target="_blank">
                            <img src="../../../../../assets/images/appBtnAndroid.png">
                        </a>
                    </div>
                </div>
        </div>
    </div>
   
   <!-- Copy Footer -->
   <div class="copyright-content">
    <div class="container">
        <div class="copyright-text text-center" *ngIf="type == 1">
            <strong>PRO.DIS. S.p.A.</strong> Via Francesco Giordani,42. 80122 - Napoli (NA)  | P.Iva 04603431216<br>
            &copy; 2020-{{anno |  date:"yyyy"}} | Tutti i marchi appartengono ai rispettivi proprietari. </div>
           <!--  <strong>PRO.DIS. S.p.A.</strong> S.s. Appia km 193,30. 81052 - Pastorano (CE)  | P.Iva 07911410632<br>
            &copy; 2020-{{anno |  date:"yyyy"}} | Tutti i marchi appartengono ai rispettivi proprietari. </div> -->

            <div class="copyright-text text-center" *ngIf="type == 2">
                <strong>INGROMARKET S.R.L.</strong> S.s. Appia km 193,30. 81052 - Pastorano (CE)  | P.Iva 07911410632<br>
                &copy; 2020-{{anno |  date:"yyyy"}} | Tutti i marchi appartengono ai rispettivi proprietari. </div> 
    </div>
</div>
</footer>